import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=84541bdc"
import script from "./versions.vue?vue&type=script&lang=ts"
export * from "./versions.vue?vue&type=script&lang=ts"
import style0 from "./versions.vue?vue&type=style&index=0&id=84541bdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports